import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'hvac-modal-header',
    templateUrl: './modal-header.component.html',
    styleUrls: ['./modal-header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ModalHeaderComponent { }
